<template>
  <div class="table-list">
    <div class="title">预警信息列表</div>
    <el-table :data="comWarningList">
      <el-table-column label="企业名称" prop="enterprise_name" width="200px" />
      <el-table-column
        label="预警类型"
        prop="warning_type_text"
        width="150px"
      />
      <el-table-column label="预警概要" prop="msg" />
      <el-table-column label="预警时间" prop="create_time" width="140px" />
      <el-table-column
        label="处置状态"
        prop="status"
        width="70px"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.handle_status_desc_text == '已处置'"
            style="color: #2BBF99"
            >{{ scope.row.handle_status_desc_text }}</span
          >
          <span v-else>{{ scope.row.handle_status_desc_text }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="130px">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="DetalisClick(scope.row)"
            >预警详情</el-button
          >
          <el-button size="mini" type="text" @click="dealClick(scope.row)"
            >预警处置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next, jumper"
      :total="total"
      :current-page.sync="currentPage"
      :page-size="10"
      @current-change="handleCurrentChange"
    />
    <warinng-detail
      :warningId="warningId"
      :visible="visible"
      :closeDialog="closeDetailDialog"
    />
    <deal-warning
      :dialogVisible="showDeal"
      :closeDialog="closeDealDialog"
      :showClose="false"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showCancelFlag="false"
      :warningId="warningId"
    />
  </div>
</template>

<script>
import WarinngDetail from './detail';
import DealWarning from './deal';

export default {
  props: {
    warningList: Array,
    total: Number
  },
  data() {
    return {
      warningId: '',
      visible: false,
      showDeal: false,
      currentPage: 1
    };
  },
  computed: {
    comWarningList() {
      return this.warningList.map(item => ({
        ...item,
        warning_type_text: this.$common.getWarningTypeText(
          item.warning_type,
          item.enterprise_type
        ),
        handle_status_desc_text: this.$common.warnDealStatus[
          item.handle_status_desc
        ]
      }));
    }
  },
  methods: {
    // 显示详情弹框
    DetalisClick(row) {
      this.companyName = row.name;
      this.warningBrief = row.bref;
      this.typeID = row.type;
      this.visible = true;
      this.warningId = row.id;
    },
    // 显示处置弹框
    dealClick(row) {
      this.showDeal = true;
      this.warningId = row.id;
    },
    // 关闭详情弹框
    closeDetailDialog(isReload) {
      this.visible = false;
      this.$emit('current-change', this.currentPage);
    },
    // 关闭处置弹框
    closeDealDialog(isReload) {
      this.showDeal = false;
      if (isReload === 'isReload') {
        this.$emit('current-change', this.currentPage);
      }
    },
    handleCurrentChange(currentPage) {
      this.$emit('current-change', currentPage);
    }
  },
  components: {
    WarinngDetail,
    DealWarning
  }
};
</script>

<style lang="stylus" scoped>
.table-list
  .title
    line-height 40px
    border-bottom 1px solid rgba(206,219,239, .5)
    margin-bottom 10px
    font-size 14px
    font-weight bold
  .el-pagination
    text-align right
    margin 20px 0 0 0
</style>
